import { SVGProps } from '@components/Icon/types';

export const ExcelDownload = ({
  fill = '#000',
  size = 24,
  ...props
}: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(3, 2)">
      <path
        d="M6.16248 10.4594L4.23795 6.97319H6.04117L6.98667 9.06053C7.06083 9.22516 7.12731 9.4278 7.18504 9.65518H7.19574C7.23301 9.51961 7.30435 9.30668 7.40482 9.03708L8.44951 6.97319H10.0993L8.13053 10.4246L10.1542 13.9464H8.40526L7.26211 11.6722C7.21973 11.5877 7.1754 11.4335 7.13009 11.2061H7.11868C7.09676 11.3123 7.0449 11.4783 6.96526 11.6956L5.82139 13.9456H4.0617L6.16248 10.4594Z"
        fill={fill}
      />
      <path
        d="M14.3307 9.88509C14.7233 9.88509 15.0415 10.1973 15.0415 10.5824V17.7915L16.8278 16.2963C17.1265 16.0463 17.5751 16.0812 17.8299 16.3742C18.0847 16.6671 18.0492 17.1073 17.7505 17.3573L14.7926 19.8332C14.6439 19.9576 14.4558 20.0125 14.2723 19.9976C14.114 19.985 13.9703 19.9214 13.8583 19.8237L10.8655 17.361C10.5648 17.1136 10.5255 16.6737 10.7777 16.3787C11.03 16.0836 11.4783 16.045 11.7791 16.2925L13.6199 17.8072V10.5824C13.6199 10.1973 13.9381 9.88509 14.3307 9.88509Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.0899174 2.28638L0 2.25383L0.0899174 2.28396V2.28638Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.28303 0C1.02737 0 0 1.01423 0 2.25383L0.0899174 2.28396V2.28638L0 2.25383V15.6772C0 16.9168 1.02737 17.9311 2.28303 17.9311H9.24646C9.54037 17.9311 9.77857 17.6972 9.77833 17.4088C9.77808 17.1208 9.54003 16.8875 9.24646 16.8875H2.28303C1.60085 16.8875 1.05708 16.3507 1.05708 15.6772V2.25383C1.05708 1.58038 1.60085 1.04356 2.28303 1.04356H8.31247C8.31441 1.04455 8.31803 1.04648 8.32384 1.05001L8.32657 1.05168L8.33381 1.05607V3.98588C8.33381 4.45454 8.51614 4.88367 8.81415 5.20746C9.15233 5.5749 9.63949 5.8067 10.1782 5.8067H13.1549L13.1586 7.3677V8.57512C13.1586 8.86153 13.3953 9.09371 13.6873 9.09371C13.9792 9.09371 14.2159 8.86154 14.2159 8.57513L14.2159 5.30663L14.2137 5.27635C14.2114 5.24326 14.208 5.19585 14.2055 5.18316C14.1851 5.08196 14.1348 4.98898 14.0609 4.916L9.62161 0.533492C9.27594 0.191629 8.80654 0 8.3175 0H2.28303ZM9.39089 3.98588V1.7814L12.4112 4.76314H10.1782C9.73808 4.76314 9.39089 4.42039 9.39089 3.98588Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'excel-download';
